<template>
  <div>
    <v-layout column class="mt-4 ml-4">
      <!-- <v-card color="grey lighten-5" class="mb-5 px-3 pb-3"> -->
      <header-elements icon='mdi-filmstrip' :showUpload="showUpload" title='Films'></header-elements>
      <elements-table :items="films" :showUpload="showUpload" @showUpload="showUpload=!showUpload" title="Film"></elements-table>

        <!-- <div class="mt-4 mb-3">
          <v-flex style="background-color:#e2e2e2;" class="px-3 py-2 elevation-1 xs12">
            <h3 class="subtitle xs12 flex">Films</h3>
            </v-flex>
        </div>       -->
            <!-- <v-divider color='black'></v-divider> -->
        <!-- <v-flex xs12 sm12 md12>
          <v-list class="xs12">
            <v-list-tile v-for="f in films" :key="f.id">
              <v-list-tile-title>
                <b>{{f.title}}</b>
              </v-list-tile-title>
              <v-list-tile-title>Duration Min: {{f.duration_min}}</v-list-tile-title>
              <v-list-tile-title>Duration Time Code: {{f.duration_timecode}}</v-list-tile-title>
              <v-list-tile-action>
                <v-btn @click="done_film" icon ><v-icon small>edit</v-icon></v-btn>
              </v-list-tile-action>
              <v-list-tile-action v-if="c_user.delete_rights">
                <v-btn @click="delete_film" icon ><v-icon small>delete</v-icon></v-btn>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider></v-divider>
          </v-list>
          <v-flex class="mt-0 mb-0 xs12" v-show="!showUpload">
            <v-btn icon @click="showUpload=!showUpload"><v-icon>add</v-icon></v-btn>
            Add new Film
          </v-flex>
          <v-flex class="mt-0 mb-0 xs12" v-show="showUpload">
            <v-btn icon @click="showUpload=!showUpload"><v-icon>close</v-icon></v-btn>
            Cancel
          </v-flex>
           -->
          <v-flex v-if="showUpload">
            <v-container grid-list-xs fluid  class="elevation-3">
              <v-layout row wrap>
                <h4 class="headline">Add new film</h4>
                <edit-field v-for="field in fields" v-show="show_field_c(field)" :id="field.name" :name="field.name"
                  :class="'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red' : '')" :artwork="artwork" 
                  :field="field" 
                  :key="field.key"
                  :film="film"
                  v-model="field.name" 
                  >
                </edit-field>
                <!-- prenos nefuguje -->
                <!-- <edit-field v-if="film.film_type=='tape'" v-for="field in fields_tape" v-show="show_field_c(field)" :id="field.name" :name="field.name"
                  :class="'flex ' + (field.class ? field.class : 'xs12') + (field.dynamic ? ' red' : '')" :artwork="artwork" 
                  :field="field" 
                  :key="field.key"
                  :film="film"
                  v-model="field.name" 
                > -->
                <!-- prenos nefuguje -->

                
                <!-- </edit-field> -->

                <!-- <v-text-field v-model="film.title" name="title" label="Title" class="flex xs12"></v-text-field> -->
                <!-- <v-textarea v-model="film.note" class="ml-2" name="note" label="Note"></v-textarea> -->
                <!-- <v-text-field v-model="film.duration_min" mask="time-with-seconds" hint="HH:MM:SS" class="flex xs6" name="duration_min" label="Duration minutes"></v-text-field>
                <v-text-field v-model="film.duration_timecode" mask="##:##:##:##" hint="HH:MM:SS:FR" class="flex xs6" name="duration_timecode" label="Duration Timecode"></v-text-field> -->
            <!-- <v-btn icon class="left mr-0 pr-0" xs12 @click="dropzone.processQueue()"><v-icon>send</v-icon></v-btn> -->
              </v-layout>
            </v-container>
            <v-btn @click="add">save</v-btn>
            <v-btn @click="showUpload=!showUpload">cancel</v-btn>
          </v-flex>
        <!-- </v-flex> -->
      <!-- </v-card> -->
    </v-layout>
  </div>
</template>

<script>
  const show_field = (field, film) => {
    if (field.condition && film) {
      // return true
      //   var a = f.condition
        // console.log(film)
        // console.log(field.condition)
      //   return eval(a)
      var theInstructions = field.condition;
      var F = (theInstructions) => {}
      return(F());
    } else {
      return true
    }
  }
  // function show_field(field, film) {
  //   // console.log(field)
  //   // console.log(film)
  //   if (field.condition && film) {
  //     // return true
  //     //   var a = f.condition
  //     //   // console.log(a)
  //     //   return eval(a)
  //     var theInstructions = field.condition;
  //     var F = new Function (theInstructions);
  //     return(F());
  //   } else {
  //     return true
  //   }
  //   // return Function('"use strict";return ("alert()")')()
  // };
  import EditField from './EditField'
  import HeaderElements from './HeaderElements'
  import languages from '@/data/languages'
  import ElementsTable from './ElementsTable'
  export default {
    props: ['artwork','film'],
    data: () => ({
      films: [
        // { id:1, title: 'Film 1', duration_min: '12 min', duration_timecode: '00:12:00:00'},
        // { id:2, title: 'Film 2', duration_min: '12 min', duration_timecode: '00:12:00:00'},
        // { id:3, title: 'Film 3', duration_min: '12 min', duration_timecode: '00:12:00:00'},
        // { id:4, title: 'Film 4', duration_min: '12 min', duration_timecode: '00:12:00:00'},
      ],
      showUpload: false,
      show: false,
      // film: {
      //   status: '',
      //   film_type: '',
      //   duration_min: '',
      //   duration_timecode: '',
      //   title: '',
      //   definition: '',
      //   color: '',
      //   sound: '',
      //   loop: '',
      //   language: '',
      //   subtitles: '',
      //   norm: '',
      //   aspect_ratio: '',
      //   fps: '',
      //   scan_type: '',
      //   vbr: '',
      //   file_size: '',
      //   audio: '',
      //   date_of_creation: '',
      //   format_migration_story: '',
      //   film_controlling_master: '',
      //   film_controlling_archive_submaster: '',
      //   operator: '',
      //   controlling_date: '',
      //   controlling_software_2: '',
      //   controlling_software_1: '',
      //   operating_system: '',
      //   controlling_computer_2: '',
      //   controlling_computer_1: '',
      //   controling_device: '',
      //   format_migration_story: '',
      //   creation_date: ''
      // },
      fields: [
        // {
        //   'ctype': 'radio',
        //   'selection': [{id: 1, name: 'monitor'},{id:2, name:'projector'},{id:3, name:'motor'}, {id:4, name:'bulb'}, {id:5, name:'switch'}],
        //   'name': 'category',
        //   'title': 'Category',
        //   column: false,
        //   class: 'xs12',
        //   work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
        //   user_groups: ['admin', 'manager']
        // },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: 'Master'}, {id: 2, name: 'Archive Submaster'}, {id: 3, name: 'Master Physical'}, {id: 4, name: 'Archival Copy'}, {id: 5, name: 'Access Copy'}, {id: 6, name: 'Other'}],
          'name': 'film.status',
          'title': 'Status',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: 'High'}, {id: 2, name: 'Standard'}],
          'name': 'definition',
          'title': 'Definition',
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: 'Color'}, {id: 2, name: 'B/W'}, {id: 3, name: 'Color & B/W'}, {id: 4, name: 'Other'}],
          'name': 'color',
          'title': 'Color',
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'name': 'norm',
          'title': 'Norm',
          selection: [{id:1,name:'PAL'},{id:2, name:'NTSC'},{id:3,name:'NTSC 4,43'},{id:4, name:'SECAM'}],
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: '4:3'}, {id: 2, name: '4:3 anamorphic'}, {id: 3, name: '16:9'}, {id: 4, name: 'IMAX'}, {id: 5, name: 'HD 720 (1280 x 720)'}, {id: 6, name: 'HD 1080 (1920x1080)'}, {id: 7, name: '2K (2048x1080)'}, {id: 8, name: 'Other'}],
          'name': 'aspect_ratio',
          'title': 'Aspect Ratio',
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: 'Progressive'}, {id: 2, name: 'Interlaced'}],
          'name': 'scan_type',
          'title': 'Scan type',
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: '24'}, {id: 2, name: '25'}, {id: 3, name: '23,97'}, {id: 4, name: '29,97'}, {id: 5, name: '50'}, {id: 6, name: '60'}],
          'name': 'fps',
          'title': 'FPS',
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'bool',
          'name': 'loop',
          'title': 'Loop',
          column: true,
          class: 'xs4 md6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'radio',
          'selection': [{id: 1, name: 'Sound'}, {id: 2, name: 'No Sound'}],
          'name': 'sound',
          'title': 'Sound',
          column: true,
          class: 'xs12 md4',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'etype': 'autocomplete',
          'selection': languages,
          'name': 'language',
          'title': 'Language',
          chips: true,
          multiple: true,
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'bool',
          'name': 'subtitles',
          'title': 'Subtitles',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'vbr',
          'title': 'Video Bit Rate in Mbps',
          column: true,
          suffix: 'Mbps',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'filesize',
          'title': 'File Size',
          column: true,
          suffix: 'MB',
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'audio',
          'title': 'Audio',
          column: true,
          class: 'xs6',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'creation_date',
          'title': 'Date of Creation',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-long',
          'selection': [{id: 1, name: 'Master'}, {id: 2, name: 'Archive Submaster'}, {id: 3, name: 'Master Physical'}, {id: 4, name: 'Archival Copy'}, {id: 5, name: 'Access Copy'}, {id: 6, name: 'Other'}],
          'name': 'format_migration_story',
          'title': 'Format Migration Story (Associated information carriers)',
          column: true,
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },

        {
          name: 'headline_conservation',
          headline: true,
          no_dynamic: true,
          title: 'Conservation',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'controling_device',
          'title': 'Controling Device',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'controlling_computer_1',
          'title': 'Controlling Computer I',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'controlling_computer_2',
          'title': 'Controlling Computer II',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'operating_system',
          'title': 'Operating System',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'controlling_software_1',
          'title': 'Controlling Software I',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'controlling_software_2',
          'title': 'Controlling Software II',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'controlling_date',
          'title': 'Controling Date',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'operator',
          'title': 'Operator',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        }
      ],
      fields_tape: [
        {
          'ctype': 'text-short',
          'name': 'player_interface_out',
          'title': 'Player | Interface Out',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'sync_generator',
          'title': 'Sync Generator',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'time_based_corrector_interface_out',
          'title': 'Time Based Corrector | Interface out',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'capture_hardware',
          'title': 'Capture Hardware',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'capture_computer',
          'title': 'Capture  Computer',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'operating_system',
          'title': 'Operating System',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'capture_software',
          'title': 'Capture Software',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'editing_software',
          'title': 'Editing Software',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'encoder',
          'title': 'Encoder',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'capture_software',
          'title': 'Control Date',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
        {
          'ctype': 'text-short',
          'name': 'operator',
          'title': 'Operator',
          class: 'xs12',
          work_types: ['pppd', 'iao', 'fvs', 'arch', 'inst'],
          user_groups: ['admin', 'manager']
        },
      ]
    }),
    methods: {
      set_input(f) {
        film[f]= f
      },
      download () {},
      add () {
        this.films.push(this.film)
        this.showUpload=!this.showUpload
      },
      delete_film () {},
      done_film () {},
      show_field_c (field) {
        // console.log(this.film)
        return show_field(field,this.film)
      }
    },
    computed: {
    },
    components: {
      EditField, HeaderElements,ElementsTable
    }
  }
</script>

<style scoped>
/* .card { min-width:250px;} */
</style>



// WEBPACK FOOTER //
// src/components/artworks/Films.vue